import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

import SearchBar from '../../component/SearchBar'
import AddDriver from './AddDriver'
import ModalAddAndEditDriver from './ModalAddAndEditDriver'
import DriversTable from './DriversTable'

import { getCompanyGroups } from '../../action/GroupsActions'
import { apiCallGet } from '../../action/RouterActions'
import { getDevicesList } from '../../action/DeviceActions'
import { formatName } from '../../component/helpers/tablesFuncHelpers'

const DriversPage = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'driversPage.driversPage' });
	const { user, company, toggleLoader, isUsingDriverFaceID } = props;
	const userRole = user.roles[0];

	const [searchText, setSearchText] = useState('')
	const [drivers, setDrivers] = useState([])
	const [initialData, setInitialData] = useState([])
	const [groups, setGroups] = useState([])

	useEffect(() => {
		if (company.company_id) {
			setSearchText('');
			getDriversGroups();
		}
	}, [company.company_id])

	const getDriversGroups = () => {
		toggleLoader(true)
		const requestArray = []
		requestArray.push(apiCallGet('/company/{companyId}/driver', { companyId: company.company_id, include_data: 'photos' }))
		requestArray.push(getDevicesList(company.company_id));
		if (['partner_view', 'sales_demo'].indexOf(userRole) === -1) {
			requestArray.push(getCompanyGroups(userRole, company, '?getids'))
		}

		Promise.all(requestArray)
			.then(res => {
				toggleLoader(false);

				const drivers = _.get(res[0], 'data.response.drivers', [])
				const groups = _.get(res[2], 'data.response.groups', [])

				setGroups(groups)
				setDrivers(drivers)
				setInitialData([...drivers])
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('getDriversError: ', error);
			})
	}

	const dataSearch = (e) => {
		const value = e.target.value.toLowerCase()
		const filter = initialData.filter(item => (
			!!item.first_name && formatName(item.first_name, item).toLowerCase().includes(value)
			|| (item.card_id && item.card_id.toLowerCase().includes(value))
		))

		setDrivers(filter)
		setSearchText(value)
	}

	const setPropStates = (states) => {
		setInitialData(states.initialData)
		setDrivers(states.drivers)
	}

	return (
		<>
			<div className='page-subheader'>
				<div className='subheader-section search'>
					<SearchBar
						term={searchText}
						placeholder={t('placeholderSearchDriver/CardID')}
						onSearch={dataSearch}
					/>
				</div>
			</div>

			<main className="main-content-block">
				{!['partner_view', 'sales_demo'].includes(userRole) &&
					<ModalAddAndEditDriver
						drivers={drivers}
						initialData={initialData}
						groups={groups}
						isUsingDriverFaceID={isUsingDriverFaceID}
						setPropStates={setPropStates}
						type={"add"}
					/>
				}

				<DriversTable
					drivers={drivers}
					initialData={initialData}
					groups={groups}
					setPropStates={setPropStates}
					isUsingDriverFaceID={isUsingDriverFaceID}
				/>
			</main>
		</>
	);
}

DriversPage.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProps = ({ user, company }) => ({
	user: user.user,
	company: company.company
});

const mapDispatchToProps = dispatch => ({
	toggleLoader: (show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(DriversPage);
